/* eslint-disable no-unused-vars */
import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import {
  MdCategory,
  MdContactSupport,
  MdManageAccounts,
  MdMenu,
  MdOutlineConstruction,
  MdOutlineExitToApp,
  MdOutlineLogout,
  MdPeopleAlt,
  MdSource,
  MdStorefront,
} from 'react-icons/md';
import { FaFileCircleQuestion } from 'react-icons/fa6';
import { NavLink, useNavigate } from 'react-router-dom';
import LogoIcon from '../../../../assets/Logo@3x.png';
import GlobalContext from '../../../../context/GlobalContext';
import { TourContext } from '../../../../context/tour';
import {
  HeaderStyled,
  ListItemTextStyled,
  LogoutButtonStyled,
  TitleStyled,
} from './header.styles';

const MENU_ITEMS = [
  {
    to: '/admin',
    icon: <MdSource size={20} />,
    label: 'Home',
    id: 'home',
  },
  {
    to: '/constructions',
    icon: <MdOutlineConstruction size={20} />,
    label: 'Obras',
    id: 'constructions',
  },
  {
    to: '/clients',
    icon: <MdPeopleAlt size={20} />,
    label: 'Clientes',
    id: 'clients',
  },
  {
    to: '/suppliers',
    icon: <MdStorefront size={20} />,
    label: 'Fornecedores',
    id: 'suppliers',
  },
  {
    to: '/categories',
    icon: <MdCategory size={20} />,
    label: 'Categorias',
    id: 'categories',
  },
  {
    to: '/faq',
    icon: <MdContactSupport size={20} />,
    label: 'FAQ',
  },
  {
    to: '/support',
    icon: <FaFileCircleQuestion size={20} />,
    label: 'Suporte',
  },
  {
    to: '/settings',
    icon: <MdManageAccounts size={20} />,
    label: 'Configurações',
  },
];

const DrawerList = ({ toggleDrawer, handleLogout }) => (
  <Box
    sx={{
      width: 250,
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
      flexGrow: 1,
    }}
    onClick={toggleDrawer}
    onKeyDown={toggleDrawer}
    id="menu-drawer"
  >
    <List>
      {MENU_ITEMS.map(({ to, icon, label, disabled, id }) => (
        <ListItem
          key={label}
          disablePadding
          component={NavLink}
          to={to}
          className={disabled ? 'disabled' : ''}
          id={id}
          sx={{
            '&.active .MuiListItemButton-root': {
              backgroundColor: (theme) =>
                label !== 'FAQ' ? theme.palette.primary.main : '',
              color: (theme) =>
                label !== 'FAQ' ? theme.palette.primary.contrastText : '',
            },
          }}
        >
          <ListItemButton disabled={disabled}>
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemTextStyled primary={label} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
    <List>
      <ListItem disablePadding>
        <ListItemButton onClick={handleLogout}>
          <ListItemIcon>
            <MdOutlineExitToApp size={20} />
          </ListItemIcon>
          <ListItemTextStyled primary="Sair" />
        </ListItemButton>
      </ListItem>
    </List>
  </Box>
);

export const Header = ({ page }) => {
  const navigate = useNavigate();
  const { companyData: company } = useContext(GlobalContext);
  const { openDrawer, setOpenDrawer } = useContext(TourContext);
  const user = JSON.parse(localStorage.getItem('user'));
  const protocol = company.subdomain.endsWith('-st') ? 'http' : 'https';

  const toggleDrawer = () => setOpenDrawer((prev) => !prev);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('company');
    navigate('/login');
  };

  return (
    <section>
      <HeaderStyled>
        {user.user_type === 'admin' ? (
          <IconButton onClick={toggleDrawer} size="large" id="menu-icon">
            <MdMenu size={20} />
          </IconButton>
        ) : (
          <img src={LogoIcon} className="logoSIOON" alt="logo sioon" />
        )}
        <TitleStyled variant="h1">{page}</TitleStyled>
        <div className="companyLogo">
          <img
            src={
              company?.logo?.url
                ? `${protocol}://${company?.subdomain}.${process.env.REACT_APP_API}${company?.logo.url}`
                : '/Logo_only.svg'
            }
            alt="logo"
            style={{ width: 250 }}
            className="logo"
          />
        </div>
        {user.user_type === 'admin' ? (
          <img src={LogoIcon} className="logoSIOON" alt="logo sioon" />
        ) : (
          <LogoutButtonStyled onClick={handleLogout}>
            <MdOutlineLogout />
            <Typography variant="h3">Sair</Typography>
          </LogoutButtonStyled>
        )}
      </HeaderStyled>
      <Drawer anchor="left" open={openDrawer} onClose={toggleDrawer}>
        <DrawerList toggleDrawer={toggleDrawer} handleLogout={handleLogout} />
      </Drawer>
    </section>
  );
};

Header.propTypes = {
  page: PropTypes.string.isRequired,
};
